import React from "react";
import './HowWeWork.scss';

function HowWeWork() {

    return (
        <div className="HowWeWork modal-bg">
            <div className="content">
                <div className={'titleKey'}>How We Work</div>
                <div className={'title'}>System Lifecycle</div>
                <div className={'text'}>
                    <span>We operate across the full system lifecycle - from problem framing to long-term system operation,<br/>
                          remaining responsible beyond delivery to ensure systems continue to operate as intended.</span>
                </div>
                <div className={'text'}>
                    <span>Systems evolve without disrupting ongoing operations.</span>
                </div>
                <div className={'cards'}>
                    <div className={'cards__item'}>
                        <div className={'number'}>
                            <span>1</span>
                        </div>
                        <div className={'description'}>
                            <span className={'title'}>
                                Problem Framing
                            </span>
                            <span className={'text'}>
                                Understanding constraints, context and real-world conditions.
                            </span>
                        </div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'number'}>
                            <span>2</span>
                        </div>
                        <div className={'description'}>
                            <span className={'title'}>
                                System Architecture
                            </span>
                            <span className={'text'}>
                                Designing system structure, boundaries and interactions.
                            </span>
                        </div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'number'}>
                            <span>3</span>
                        </div>
                        <div className={'description'}>
                            <span className={'title'}>
                                Implementation
                            </span>
                            <span className={'text'}>
                                Building systems aligned with architecture and operational needs.
                            </span>
                        </div>
                    </div>
                    <div className={'cards__item'}>
                        <div className={'number'}>
                            <span>4</span>
                        </div>
                        <div className={'description'}>
                            <span className={'title'}>
                                Production Operation
                            </span>
                            <span className={'text'}>
                                Supporting, evolving and maintaining systems in real environments.
                            </span>
                        </div>
                    </div>
                </div>
                <div id={'where-we-engage'}/>
            </div>
        </div>
    );
}

export default HowWeWork;